export const MAINTAIN_WEIGHT = '1'
export const LOSE_WEIGHT = '2'
export const GAIN_WEIGHT = '0'

export default [MAINTAIN_WEIGHT, GAIN_WEIGHT, LOSE_WEIGHT]
